import React from 'react';
import { useIntl } from 'react-intl';
import { getWarehouseApiUrl } from '../../../helpers/url';
import Comments from './Comments';

interface ProductCommentsProps {
    id: number;
    onAdd: () => void;
}

const url = (id: number) => getWarehouseApiUrl('products/:id/comments', { params: { id } });

export default ({ id, onAdd }: ProductCommentsProps) => {
    const { formatMessage } = useIntl();
    const title = formatMessage({ id: 'comments.product.title', defaultMessage: 'Product comments' });

    return <Comments url={url(id)} title={title} onAdd={onAdd} />;
}
